var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaDataroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_dataroom",
    "data-name": "icona dataroom",
    transform: "translate(-10181 7387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4637",
    "data-name": "Raggruppa 4637",
    transform: "translate(4.5 -31.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2229",
    "data-name": "Tracciato 2229",
    d: "M71.579,95.646h7.776a.374.374,0,0,0,.379-.379A4.3,4.3,0,0,0,78.5,92.232a3.743,3.743,0,0,0-1.47-.948A2.063,2.063,0,0,0,77.364,91a2.686,2.686,0,0,0,.806-1.9,2.5,2.5,0,0,0-.806-1.9,2.686,2.686,0,0,0-1.9-.806,2.5,2.5,0,0,0-1.9.806,2.686,2.686,0,0,0-.806,1.9,2.5,2.5,0,0,0,.806,1.9c.095.095.237.19.332.284a4.357,4.357,0,0,0-1.47.948A4.3,4.3,0,0,0,71.2,95.267.408.408,0,0,0,71.579,95.646Zm2.56-5.216a1.9,1.9,0,0,1-.569-1.328,1.722,1.722,0,0,1,.569-1.328,1.9,1.9,0,0,1,1.328-.569,1.722,1.722,0,0,1,1.328.569,1.9,1.9,0,0,1,.569,1.328A1.722,1.722,0,0,1,76.8,90.43,1.9,1.9,0,0,1,75.467,91,2.13,2.13,0,0,1,74.14,90.43ZM73,92.8a3.557,3.557,0,0,1,2.466-1.043A3.364,3.364,0,0,1,77.933,92.8a3.6,3.6,0,0,1,1,2.086H72.006A3.468,3.468,0,0,1,73,92.8Z",
    transform: "translate(10107.3 -7439.985)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2230",
    "data-name": "Tracciato 2230",
    d: "M96.443,90.3H93.223c-.077,0-.123.15-.123.3,0,.188.062.3.123.3h3.219c.077,0,.123-.15.123-.3S96.52,90.3,96.443,90.3Z",
    transform: "translate(10093.935 -7441.885)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2231",
    "data-name": "Tracciato 2231",
    d: "M96.443,95.9H93.223c-.077,0-.123.15-.123.3,0,.188.062.3.123.3h3.219c.077,0,.123-.15.123-.3S96.52,95.9,96.443,95.9Z",
    transform: "translate(10093.935 -7446.485)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2232",
    "data-name": "Tracciato 2232",
    d: "M96.443,101.5H93.223c-.077,0-.123.15-.123.3,0,.188.062.3.123.3h3.219c.077,0,.123-.15.123-.3S96.52,101.5,96.443,101.5Z",
    transform: "translate(10093.935 -7451.085)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2251",
    "data-name": "Tracciato 2251",
    d: "M83.057,112.4H71.516c-.135,0-.216.15-.216.3,0,.188.108.3.216.3H83.057c.135,0,.216-.15.216-.3S83.192,112.4,83.057,112.4Z",
    transform: "translate(10107.227 -7456.039)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2252",
    "data-name": "Tracciato 2252",
    d: "M96.443,101.5H93.223c-.077,0-.123.15-.123.3,0,.188.062.3.123.3h3.219c.077,0,.123-.15.123-.3S96.52,101.5,96.443,101.5Z",
    transform: "translate(10093.935 -7450.085)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2253",
    "data-name": "Tracciato 2253",
    d: "M83.057,112.4H71.516c-.135,0-.216.15-.216.3,0,.188.108.3.216.3H83.057c.135,0,.216-.15.216-.3S83.192,112.4,83.057,112.4Z",
    transform: "translate(10107.227 -7455.039)",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1976",
    "data-name": "Rettangolo 1976",
    transform: "translate(10181 -7387)",
    fill: "none",
    stroke: "#757575",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 15.2,
    height: 15.2,
    rx: 1.6,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaDataroom);
export default __webpack_public_path__ + "static/media/icona_dataroom.33f473e5f913f7798c740f25ac294daa.svg";
export { ForwardRef as ReactComponent };